export type MenuItemData = UserMenuItem | PosMenuItem;
export type MenuItemVariation = UserMenuItemVariation | PosMenuItemVariation;

export enum MenuItemType {
  USER_MENU_ITEM = 'user-item',
  POS_MENU_ITEM = 'pos-item',
}

export interface MenuItem {
  id: string;
  name: string;
  price?: string;
  description: string;
  type: MenuItemType;
  iconsList: string[];
  variationsList: MenuItemVariation[];
  addOnsList: MenuItemVariation[];
  categories: MenuItemTag[];
}

export interface UserMenuItem extends MenuItem {
  type: MenuItemType.USER_MENU_ITEM;
}

export interface PosMenuItem extends MenuItem {
  posItemId: string;
  type: MenuItemType.POS_MENU_ITEM;
  source: string;
}

export interface ItemVariation {
  id: string;
  name: string;
  price: string;
}

export interface UserMenuItemVariation extends ItemVariation {
  type: MenuItemType.USER_MENU_ITEM;
}

export interface PosMenuItemVariation extends ItemVariation {
  posVariationId: string;
  type: MenuItemType.POS_MENU_ITEM;
}

export interface MenuItemTag {
  id: string;
  name: string;
  isSelected: boolean;
}
